export const parseDateToDefaultFormat = (date) => {
  const newDate = new Date(date);
  return `${newDate.getMonth() + 1}/${newDate.getDate()}/${newDate.getFullYear()}`;
}

export const parseDateToStringFormat = (date) => {
  const newDate = new Date(date);
  return newDate.toDateString();
}